import { post, patch, put, del, get } from 'aws-amplify/api';
import { processResponse } from './api_util';
import useSWR, { mutate } from 'swr'
import { handleApiResponse } from './api_util';


async function getQuotaByName(quotaName) {

  const payload = {
    apiName: 'LivisiblyQuotaApi',
    path: `quotas/${quotaName}`

  }

  const restOperation = get(payload);


  const response = await restOperation.response;

  return processResponse(response)
}


export function useGetQuotaByName(quotaName,shouldFetch = true) {
  const result = useSWR(
    shouldFetch ? ['QUOTAS', quotaName] : null,
    (path) => getQuotaByName(quotaName)
  );
  return result;
}

async function getQuotas() {

  const payload = {
    apiName: 'LivisiblyQuotaApi',
    path: 'quotas'

  }

  const restOperation = get(payload);


  const response = await restOperation.response;

  return processResponse(response)
}


export function useGetQuotas(shouldFetch = true) {
  const result = useSWR(
    shouldFetch ? 'QUOTAS' : null,
    (path) => getQuotas()
  );
  return result;
}

const updateQuotas = async (updates) => {
//   console.log('updateQuotas')
//   console.log(JSON.stringify(updates, null, 2))

  const payload = {
    apiName: 'LivisiblyQuotaApi',
    path: 'quotas',
    options: {
      body: {
        quotas: updates,
      }
    }
  }

  const restOperation = post(payload);

  const response = await restOperation.response;

  return processResponse(response)
}


export function useUpdateQuotas() {
return (updates) => {
    const options = {
      optimisticData: updates, // Optimistically update the cache
      revalidate: true,  // Don't revalidate immediately because the mutation will return the updated data
    }
    mutate(`QUOTAS`,
      updateQuotas(updates) // Call the update function
      , options);
  };

}